// The intake form's add-on checkboxes as the POST's addons list:
// [{ addonId, detail }] for each ticked add-on, in the order offered. A detail
// is sent only for an add-on that asks for one, trimmed, and null when blank.
export const intakeAddonsPayload = (options, choices) => (options || [])
  .filter((addon) => choices && choices[addon.id] && choices[addon.id].checked)
  .map((addon) => {
    const raw = addon.detailLabel ? String(choices[addon.id].detail || '').trim() : '';
    return { addonId: addon.id, detail: raw || null };
  });
